import { useCreditUsageItem } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { NotificationPopupNoteCostProps as Props } from './types';

export const NotificationPopupNoteCost = memo(({ className, type }: Props) => {
  const { credit } = useCreditUsageItem(type);

  return (
    <Styled.Wrapper
      className={classnames('NotificationPopupNoteCost', className)}
      sx={SX.root}
    >
      <Typography variant="body4">{!credit ? 'Free' : `${credit}`}</Typography>
    </Styled.Wrapper>
  );
});

NotificationPopupNoteCost.displayName = 'NotificationPopupNoteCost';
